import reportService from "@/services/mrfiktiv/services/reportService";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { FetchStrategy, SharedContentDocument, safeFetch } from "../SharedContentFetchStrategy";

export class ReportFetchStrategy implements FetchStrategy {
  canHandle(refType: string): boolean {
    return refType === ResourceEnum.REPORT;
  }

  fetch(partnerId: string, refId: string, sct: string): Promise<SharedContentDocument> {
    return safeFetch(refId, ResourceEnum.REPORT, async () => {
      const response = await reportService.getDocumentBySharedAccessToken(partnerId, refId, sct);
      return response.report;
    });
  }
}
